import { render } from "./dashboardNews.vue?vue&type=template&id=092273dc&scoped=true"
import script from "./dashboardNews.vue?vue&type=script&lang=js"
export * from "./dashboardNews.vue?vue&type=script&lang=js"

import "./dashboardNews.vue?vue&type=style&index=0&id=092273dc&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092273dc"]])

export default __exports__